import attackDirect from './attack_direct_effect';
import attackMonster from './attack_monster_effect';
import battleDirect from './battle_direct_effect';
import battleMonster from './battle_monster_effect';
import becomeTargetField from './become_target_field_effect';
import becomeTargetElsewhere from './become_target_elsewhere_effect';
import chainDisabled from './chain_disabled_effect';
import chainEnd from './chain_end_effect';
import chainNegated from './chain_negated_effect';
import chainSolved from './chain_solved_effect';
import chainSolvingZoom from './chain_solving_zoom_effect';
import chainSolvingSink from './chain_solving_sink_effect';
import chainingField from './chaining_field_effect';
import chainingElsewhere from './chaining_elsewhere_effect';
import confirmCards from './confirm_cards_effect';
import damageBattle from './damage_battle_effect';
import damageEffect from './damage_effect_effect';
import damageStepEnd from './damage_step_end_effect';
import damageStepStart from './damage_step_start_effect';
import draw from './draw_effect';
import flipsummoned from './flipsummoned_effect';
import flipsummoning from './flipsummoning_effect';
import moveDestroy from './move_destroy_effect';
import moveDestroyElsewhere from './move_destroy_elsewhere_effect';
import moveLeave from './move_leave_effect';
import moveElsewhere from './move_elsewhere_effect';
import moveMaterial from './move_material_effect';
import moveEnter from './move_enter_effect';
import moveAfterActivation from './move_after_activation_effect';
import newPhaseBattle from './new_phase_battle_effect';
import newPhaseOther from './new_phase_other_effect';
import newTurn from './new_turn_effect';
import payLpcost from './pay_lpcost_effect';
import posChangeFlip from './pos_change_flip_effect';
import posChangeTurn from './pos_change_turn_effect';
import posChangeSpell from './pos_change_spell_effect';
import recover from './recover_effect';
import set from './set_effect';
import shuffleDeck from './shuffle_deck_effect';
import shuffleHand from './shuffle_hand_effect';
import spsummoned from './spsummoned_effect';
import spsummoningPlain from './spsummoning_plain_effect';
import spsummoningSynchro from './spsummoning_synchro_effect';
import spsummoningFusion from './spsummoning_fusion_effect';
import spsummoningRitual from './spsummoning_ritual_effect';
import spsummoningXyz from './spsummoning_xyz_effect';
import spsummoningLink from './spsummoning_link_effect';
import summoned from './summoned_effect';
import summoning from './summoning_effect';
import win from './win_effect';

/**
 * **arcade の演出**（Issue #529 / #628）。**1 ファイル = 1 状況 × 役割**（ファイル名が `<situation>_<role>`。
 * 状況は共通側の分岐レイヤー `editorPorts/duelSituations/` のカタログ）。arcade は契約の確認用なので、
 * 分岐のある状況（move の 7 つなど）は共有の組み立て（`../fx/<event>.js`）を薄いファイルが呼ぶだけで、どの状況も同じ絵。
 *
 * 置けば出る・消せば出ない。**そのテーマで出さない演出はファイルを置かないだけ**
 * （旧 `components/fx` の `skins` の `hidden` にあたる仕組みは要らない）。
 *
 * `require.context` を使わないのは jest と webpack で読み方が変わるのを避けるため
 * （`themes/index.js` / `parts/index.js` と同じ）。
 */

export const EFFECTS = Object.freeze([
  attackDirect, attackMonster, battleDirect, battleMonster, becomeTargetField, becomeTargetElsewhere, chainDisabled, chainEnd, chainNegated, chainSolved, chainSolvingZoom, chainSolvingSink, chainingField, chainingElsewhere, confirmCards, damageBattle, damageEffect, damageStepEnd, damageStepStart, draw, flipsummoned, flipsummoning, moveDestroy, moveDestroyElsewhere, moveLeave, moveElsewhere, moveMaterial, moveEnter, moveAfterActivation, newPhaseBattle, newPhaseOther, newTurn, payLpcost, posChangeFlip, posChangeTurn, posChangeSpell, recover, set, shuffleDeck, shuffleHand, spsummoned, spsummoningPlain, spsummoningSynchro, spsummoningFusion, spsummoningRitual, spsummoningXyz, spsummoningLink, summoned, summoning, win,
]);
